import { ColumnDef } from "@tanstack/react-table"

import { MeterReaderZoneType } from "@/types/meter"

import { DataTableColumnHeader } from "../../data-table"
import { EditMeterReaderOperations } from "../operations/edit-meter-reader-operations"

export const meterReaderColumns: ColumnDef<MeterReaderZoneType>[] = [
  {
    accessorKey: "id",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="ID" />
    ),
    cell: ({ row }) => {
      const value = row.original.id
      return <div>{value}</div>
    },
  },
  {
    accessorKey: "name",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Name" />
    ),
    cell: ({ row }) => {
      const value = row.original.name
      return <div>{value}</div>
    },
  },
  {
    accessorKey: "initials",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Initials" />
    ),
    cell: ({ row }) => {
      const value = row.original.initials
      return <div>{value}</div>
    },
  },
  {
    accessorKey: "zone",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Zone" />
    ),
    cell: ({ row }) => {
      const value = row.original.zone
      return <div>{value}</div>
    },
  },
  {
    accessorKey: "description",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Description" />
    ),
    cell: ({ row }) => {
      const value = row.original.description
      return <div>{value}</div>
    },
  },
  {
    accessorKey: "actions",
    header: () => {
      return <div className="text-center dark:text-white">Actions</div>
    },
    cell: ({ row }) => {
      return (
        <div className="px-4 py-2 text-center md:py-0 md:text-center">
          <EditMeterReaderOperations data={row.original} />
        </div>
      )
    },
  },
]
